// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.texto_cookie {
    display: flex;
    flex-direction: column;
    text-align: justify;
    justify-content: center;
    align-items: center;
    background-color: #a2d1e0;
    border-radius: 5px;
    margin-top: 50px;
  }

  button.boton_cookie {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: white;
    background-color: rgb(170, 157, 152);
    margin-left: 20px;
    padding: 10px;
    border-radius: 20px;
    border: double 7px rgb(158, 224, 252,0.777);
    font-style: bold;
}`, "",{"version":3,"sources":["webpack://./src/css/CookieBanner.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;IACpC,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;AACpB","sourcesContent":[".texto_cookie {\r\n    display: flex;\r\n    flex-direction: column;\r\n    text-align: justify;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #a2d1e0;\r\n    border-radius: 5px;\r\n    margin-top: 50px;\r\n  }\r\n\r\n  button.boton_cookie {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    color: white;\r\n    background-color: rgb(170, 157, 152);\r\n    margin-left: 20px;\r\n    padding: 10px;\r\n    border-radius: 20px;\r\n    border: double 7px rgb(158, 224, 252,0.777);\r\n    font-style: bold;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
